import { EntityTypeEnum } from 'common/enums/entityTypeEnum'
import { HeadingTypeEnum } from 'common/enums/HeadingTypeEnum'
import type { ContentTableInterface } from 'common/types/entities/ContentTableInterface'
import { BorderStyleEnum } from 'common/types/styleTypes'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'
import type { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'

export const createBlogPostContentTable = (
  parentId: string,
  masterBlockId?: MasterBlockIdType,
): ContentTableInterface => {
  return {
    ...generateBaseEntity(EntityTypeEnum.ContentTable, parentId, masterBlockId),
    isOpenedByDefault: true,
    backgroundColor: 'rgba(248, 248, 249, 0.6)',
    headersTypes: [HeadingTypeEnum.HeaderTwo, HeadingTypeEnum.HeaderThree],
    content: [],
    iconClassName: 'fas fa-chevron-circle-up',
    iconColor: 'rgba(27, 160, 255, 1)',
    headerTitle: '',
    headerFontSize: 32,
    headerColor: 'rgba(0, 0, 0, 1)',
    contentColor: 'rgba(27, 160, 255, 1)',
    contentFontSize: 24,
    contentItemGap: 10,
    border: {
      radius: 3,
      width: 1,
      style: BorderStyleEnum.solid,
      color: 'rgba(215, 215, 228, 1)',
    },
    padding: {
      paddingTop: 30,
      paddingRight: 70,
      paddingBottom: 30,
      paddingLeft: 70,
    },
    mobilePadding: {
      paddingTop: 10,
      paddingRight: 20,
      paddingBottom: 10,
      paddingLeft: 20,
    },
  }
}
